import ArrowLeft16 from '@carbon/icons-react/es/arrow--left/16';
import { Space } from 'antd';
import { ColumnType } from 'antd/lib/table';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IntegrationField, JiraIssueType } from 'api/integrations';
import { Switch } from 'components/atoms/switch/switch';
import { generateDefaultTableCells } from '../render-fields';
import { getFieldLabel } from './dynamic-table-columns';

export const getDefaultTableColumns = ({
  issueTypes = [],
  loading,
  onIssueTypeChange,
}: {
  issueTypes?: JiraIssueType[];
  loading?: boolean;
  onIssueTypeChange: (valObject: any) => void;
}): ColumnType<IntegrationField>[] => [
  {
    title: <FormattedMessage id="settings.integrations.jira.table.fields" />,
    dataIndex: 'fieldName',
    width: 400,
    render: (fieldName, row) => {
      return getFieldLabel(fieldName, row.required);
    },
  },
  {
    key: 'arrow',
    render: () => <ArrowLeft16 />,
    width: 16,
  },
  {
    title: <FormattedMessage id="settings.integrations.jira.table.set_value" />,
    dataIndex: 'metaData',
    width: 340,
    render: (metaData, row) => {
      return generateDefaultTableCells({
        field: row,
        issueTypes,
        onIssueTypeChange,
        loading,
      });
    },
  },
  {
    title: (
      <FormattedMessage id="settings.integrations.jira.table.show_field" />
    ),
    dataIndex: 'isEnabled',
    render: () => (
      <Space size={16}>
        <Switch size="small" checked disabled loading={loading} />
      </Space>
    ),
  },
];
